import { Component, For } from "solid-js";
import { Locale, setLocale } from "../../../i18n.js";
import GetFlagImg from "../../utils/GetFlagImgProps.jsx";

const LanguageSwitcher: Component = () => {
  const localLocale: Record<Locale, string> = {
    [Locale.US]: "English",
    [Locale.FR]: "Français",
  };

  return (
    <div class="dropdown dropdown-end">
      <div
        tabindex="0"
        role="button"
        class="btn btn-ghost rounded-field text-2xl"
      >
        <i class="fa-light fa-flag"></i>
      </div>
      <ul
        tabindex="0"
        class="menu dropdown-content bg-base-200 rounded-box z-1 mt-4 min-w-40 p-2 drop-shadow-lg"
      >
        <For each={Object.values(Locale)}>
          {(locale) => (
            <li>
              <button
                class="flex items-center gap-4"
                onClick={(e: Event) => {
                  setLocale(locale);
                }}
              >
                <GetFlagImg locale={locale} size={20} />
                <p>{localLocale[locale]}</p>
              </button>
            </li>
          )}
        </For>
      </ul>
    </div>
  );
};

export default LanguageSwitcher;
